module.exports = __webpack_public_path__ + "img/a_la_carte.2976d3fc.jpg";